import 'rxjs/add/operator/map';
import {FormControl} from "@angular/forms";

export class ValidatorService {

    static positiveValue(c){
        return (!!c.value && c.value > 0);
    }

    static lessThanOrEqualTo(c, max) {
        return (!!c.value && c.value <= max);
    }

    static moreThanOrEqualTo(c, min) {
        return (!!c.value && c.value >= min);
    }

    static containsValue(c: FormControl){
        return (!!c.value);
    }

    static notEmptyList(c: FormControl) {
        return (!!c.value && c.value.length > 0);
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/core/validator.service.ts